import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import ConvertNumber from '../components/ConvertNumber';
import EDSFooter from '../components/EDSFooter';
import { useSelector, useDispatch } from 'react-redux';
import { setNip } from '../reducers/reposReducers';
import InputMask from 'react-input-mask';

const Platnosc = () => {
    let getGroup = useSelector((state) => state.repos.groups);
    let payForm = useSelector((state) => state.repos.payForm);

    const dispatch = useDispatch();
    let dateToBay = useSelector((state) => state.repos.date);
    let coursesHeadings = useSelector((state) => state.repos.coursesHeadings);
    let payzero = useSelector((state) => state.repos.payzero);
    let entryFee = useSelector((state) => state.repos.entryFee);

    let users = useSelector((state) => state.repos.users);
    let usersParticipant = useSelector((state) => state.repos.usersParticipant);

    const [checkbox, setcheckbox] = useState(false);
    const [nip, setnip] = useState();

    const allInstallmentsPrice = useSelector((state) => state.repos.allInstallmentsPrice);

    function setcheckboxOnOff(){
        setcheckbox(!checkbox)
        if(checkbox === true){
            setnip('')
            dispatch(setNip(nip));
        }
    }

    const key = useSelector((state) => state.repos.chName);
    if (!key || key == '') {
        localStorage.clear();
       
        history.push('/Error_sesja_wygasla');
    }

    if (!getGroup) {
        getGroup = JSON.parse(localStorage.getItem('getGroup'));
    }
    if (!payForm) {
        payForm = JSON.parse(localStorage.getItem('payForm'));
    }
    if (!dateToBay) {
        if (localStorage.getItem('dateToBay') !== 'undefined') {
            dateToBay = JSON.parse(localStorage.getItem('dateToBay'));
        }
    }

    if (!coursesHeadings) {
        coursesHeadings = JSON.parse(localStorage.getItem('coursesHeadings'));
    }
    const history = useHistory();

    const save = (e) => {
        e.preventDefault();
        dispatch(setNip(nip));
        history.push('/operacja_w_toku');
    };

    function paymentsMetod(method) {
        if (method.periodsOfValidityDVID === 1) {
            return 'Roczna '+ method.paymentDVIDName
        } else
            if (method.periodsOfValidityDVID === 2) {
                return 'Semestralna '+ method.paymentDVIDName
            } else
                if (method.periodsOfValidityDVID === 3) {
                    return 'Miesięczna '+ method.paymentDVIDName
                }
        return ''
    }

  
    return getGroup ? (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">
                        Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                    </span>
                </div>
            </header>
            <div className="content">
                <div>
                    <a href="">
                        <Link to="/Umowa">
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                </div>
                <ProfileHeader></ProfileHeader>
                <aside className="registration-steps margin-top-32">
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">1</span>
                        </div>
                        <span className="step__text">Wybór&nbsp;kursu</span>
                    </div>
                    <div className="step">
                        <div className="step__circle">
                            <span className="step__count">2</span>
                        </div>
                        <span className="step__text">Umowa</span>
                    </div>
                    <div className="step">
                        <div className="step__circle step__circle--active">
                            <span className="step__count">3</span>
                        </div>
                        <span className="step__text">Płatność</span>
                    </div>
                </aside>
                <section className="recap responsive-padding margin-top-64">
                    <div className="selected-course">
                        <div className="selected-course-top-box">
                            <span className="selected__title"> WYBRAŁEŚ KURS:&nbsp;</span>
                            <span id="selected-title" className="selected__title text-large">
                                {'  ' + coursesHeadings.courseHeadingName}
                            </span>
                        </div>

                        <div className="selected-course-box">
                            <h3 className="fw-700 margin-top-16">styl taneczny:{' '}</h3>
                            <span id="selected-time" className="selected__time">
                                {coursesHeadings.courseDanceStyle}
                            </span>


                            <h3 className="fw-700 margin-top-16"> czas zajęć:{' '}</h3>
                            <span id="selected-time" className="selected__time">
                                {coursesHeadings.DurationMin} min
                            </span>

                            <h3 className="fw-700 margin-top-16"> w tygodniu:{' '}</h3>
                            <span id="selected-weekly" className="selected__weekly">
                                {coursesHeadings.Frequency}
                            </span>

                            <ul id="selected-list" className="selected__list margin-top-8">
                                <li className="selected__list-item">
                                    {localStorage.getItem('CourseTime')}
                                </li>
                            </ul>
                            <h3 className="fw-700 margin-top-16">Uczestnik</h3>
                            <p id="selected__participant" className="selected__choice">
                                {usersParticipant
                                    ? usersParticipant.firstName + ' ' + usersParticipant.lastName
                                    : users.firstName + ' ' + users.lastName}
                            </p>
                            <h3 className="fw-700 margin-top-16">Data rozpoczęcia</h3>
                            <p id="selected__date" className="selected__choice">
                                {dateToBay}
                            </p>
                        </div>
                        <div className="selected-course-box">
                            <h3 className="fw-700 margin-top-16">Wariant cenowy</h3>
                            <p id="selected__variant" className="selected__choice">
                                {paymentsMetod(getGroup)}
                            </p>
                            <h3 className="fw-700 margin-top-16">Forma płatności</h3>
                            <p id="selected__payment" className="selected__choice">
                                {payForm.selectedPaymentMethod == 5
                                    ? 'Przelewy 24'
                                    : 'Karta kredytowa lub debetowa'}
                            </p>
                            <h3 className="fw-700 margin-top-16">koszt kursu</h3>
                            <p id="selected__total" className="selected__choice">
                                {ConvertNumber(allInstallmentsPrice)} zł
                            </p>
                            <h3 className="fw-700 margin-top-16">
                                {getGroup.paymentTypesDVID == 2 ? 'wartość raty zero (pro-raty)' : ''}
                            </h3>
                            <p id="selected__total" className="selected__choice">
                                {getGroup.paymentTypesDVID == 2 ? ConvertNumber(payzero.paymentPositionPrice) + 'zł' : ''}
                            </p>
                            <div>
                                <h3 className="fw-700 margin-top-16">
                                    {getGroup.paymentTypesDVID === 2 ? 'Rata miesięczna' : ''}
                                </h3>
                                <p id="selected__installment" className="selected__choice">
                                    {' '}
                                    {getGroup.paymentTypesDVID === 2
                                        ? ConvertNumber(+getGroup.unitAmount) + 'zł'
                                        : ''}
                                </p>
                            </div>

                            <h3 className="fw-700 margin-top-16">do opłacenia</h3>
                            <p id="selected__installments" className="selected__choice">
                                {ConvertNumber(+localStorage.getItem('suma'))} zł
                            </p>
                            
                        </div>
                    </div>
                    <main className="margin-top-32">
                    <div className='payment-amount'>
                            <div className="payment-amount-course-box">
                                <h2 className="h2">Płatność</h2>
                                <h3 className="h3 margin-top-32">Opłać zamówienie</h3>
                                <form id="pay-form" method="post" action="" onSubmit={(e) => save(e)}>
                                    <ul className="pay-sums__list margin-top-16">
                                        <li className="pay-sums__item">
                                            <span className="pay-sums__item-title">Wybrane raty:</span>
                                            <span className="pay-sums__item-value">
                                                <span id="pay-installments">
                                                    {entryFee.priceDiscount
                                                        ? ConvertNumber(
                                                            +localStorage.getItem('suma') -
                                                            entryFee.priceDiscount
                                                        )
                                                        : ConvertNumber(+localStorage.getItem('suma'))}
                                                </span>{' '}
                                                zł
                                            </span>
                                        </li>
                                        <li className="pay-sums__item">
                                            <span className="pay-sums__item-title">Opłata wpisowa:</span>
                                            <span className="pay-sums__item-value">
                                                <span id="pay-entrance-fee">
                                                    {ConvertNumber(
                                                        entryFee.priceDiscount ? entryFee.priceDiscount : 0
                                                    )}
                                                </span>{' '}
                                                zł
                                            </span>
                                        </li>
                                        <li className="pay-sums__item margin-top-8">
                                            <span className="pay-sums__item-title">SUMA:</span>
                                            <span className="pay-sums__item-value">
                                                <span id="pay-total">
                                                    {ConvertNumber(+localStorage.getItem('suma'))}
                                                </span>{' '}
                                                zł
                                            </span>
                                        </li>
                                    </ul>
                                    <input
                                        type="submit"
                                        className="pay-submit btn-primary-responsive margin-top-32"
                                        value="Dokonuję płatności"
                                    />
                                </form>
                            </div>
                            <div className="payment-amount-course-box">
                                <div className="inpit-nip">
                                    <input
                                        className="form__checkbox"
                                        type="checkbox"
                                        name="accept-contract2"
                                        id="accept-contract2"
                                        onClick={() => setcheckboxOnOff()}

                                        checked={checkbox}
                                        required
                                    />
                                    <label className="form__label--checkbox" htmlFor="accept-contract2">
                                        NIP DO PARAGONU
                                    </label>
                                    <span className="inpit-nip-input">{' '}
                                        {checkbox? 
                                         <InputMask
                                            className="form__input"
                                            title="NIP"
                                            name="nip"
                                            mask="9999999999"
                                            maskChar="_"
                                            onChange={(e) => {
                                                setnip(e.target.value);
                                            }}
                                            value={nip}
                                            required
                                        ></InputMask>
 
                                        : '' }
                                        </span>
                                </div>
                            </div>
                        </div>

                    </main>
                </section>
            </div>
            <div>
                {/* <button onClick={() => stattt()}> dsfjdlkfj</button> */}
            </div>
            <EDSFooter></EDSFooter>
        </>
    ) : (
        ''
    );
};
export default Platnosc;
